import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

export interface SectionPulloutProps extends ComponentProps<'div'> {
  left?: boolean
  right?: boolean
  top?: boolean
  bottom?: boolean
}

export const SectionPullout = (props: SectionPulloutProps) => {
  const {
    left = true,
    right = true,
    top = false,
    bottom = false,
    children,
    className,
    ...restProps
  } = props

  const isPullout = top || bottom || left || right

  return (
    <div
      className={twMerge(
        top && '-mt-spacing-56 @medium/section:mt-[-12.55cqw]', // 12.55 is used instead of 12.5 adjust for percentage rounding
        bottom && '-mb-spacing-56 @medium/section:mb-[-12.55cqw]', // 12.55 is used instead of 12.5 adjust for percentage rounding
        left && '-ml-spacing-20 @medium/section:ml-[-12.55cqw]', // 12.55 is used instead of 12.5 adjust for percentage rounding
        right && '-mr-spacing-20 @medium/section:mr-[-12.55cqw]', // 12.55 is used instead of 12.5 adjust for percentage rounding
        // Add extra spacing between blocks when this block does not have a pullout, but the next one does
        !isPullout && '[&:has(+[data-pullout="true"])]:pb-spacing-8 @block-medium:[&:has(+[data-pullout="true"])]:pb-block-medium',
        // Add extra spacing between blocks when this block does have a pullout, but the next one does not
        isPullout && '[&:has(+[data-pullout="false"])]:pb-spacing-8 @block-medium:[&:has(+[data-pullout="false"])]:pb-block-medium',
        // Reduce spacing between blocks to 0 if both blocks have a pullout
        isPullout && '[&:has(+[data-pullout="true"])]:-mb-spacing-48 @medium/section:[&:has(+[data-pullout="true"])]:-mb-block-medium',
        // used to add border-radius to block corners when blocks are pullout at first or last position,
        //  together with data-pullout-top/-bottom
        'group/pullout',
        className,
      )}
      data-pullout={isPullout}
      // used to add border-radius to block corners when blocks are pullout at first position,
      //  together with 'group/pullout'
      data-pullout-top={top}
      // used to add border-radius to block corners when blocks are pullout at last position,
      //  together with 'group/pullout'
      data-pullout-bottom={bottom}
      {...restProps}
    >
      {children}
    </div>
  )
}
